// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"d0370e96","233":"96ad28ad","289":"7f4a1bc3","291":"69aead41","433":"c60587f1","480":"26c33559","719":"06ad89a4","786":"700afd14","912":"791885d6"}[chunkId] + ".chunk.css";
};